var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorGredientSizeRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 40,
    viewBox: "0 0 161 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1587_9844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.552734 39.9999V0.466766H14.7613V28.14H35.2744V39.9999H0.552734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.552734 39.9999V0.466766H14.7613V28.14H35.2744V39.9999H0.552734Z",
    fill: "url(#paint0_linear_1587_9844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4521 39.9999V0.466766H89.7308L101.116 20.0921H102.434V0.466766H116.313V39.9999H100.364L88.6017 20.3745H87.3314V39.9999H73.4521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4521 39.9999V0.466766H89.7308L101.116 20.0921H102.434V0.466766H116.313V39.9999H100.364L88.6017 20.3745H87.3314V39.9999H73.4521Z",
    fill: "url(#paint1_linear_1587_9844)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7783 19.4862L71.9838 0.466766H57.0695L53.6063 6.68155L58.4776 15.4231L60.7783 19.4862ZM55.8463 27.8576V39.9999H41.5906V27.7164L25.5 0.466766H40.4614L48.2244 14.3975L55.8463 27.8576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7783 19.4862L71.9838 0.466766H57.0695L53.6063 6.68155L58.4776 15.4231L60.7783 19.4862ZM55.8463 27.8576V39.9999H41.5906V27.7164L25.5 0.466766H40.4614L48.2244 14.3975L55.8463 27.8576Z",
    fill: "url(#paint2_linear_1587_9844)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.977 20.2804L115.427 39.9999H130.906L137.258 29.646H138.622L144.974 39.9999H156.304L137.258 10.2559L131.047 0.466766H115.804L128.977 19.5745V20.2804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.977 20.2804L115.427 39.9999H130.906L137.258 29.646H138.622L144.974 39.9999H156.304L137.258 10.2559L131.047 0.466766H115.804L128.977 19.5745V20.2804Z",
    fill: "url(#paint3_linear_1587_9844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.785 0.466766H160.076L152.14 12.0599L150.803 14.0132L143.475 2.5489L144.785 0.466766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.785 0.466766H160.076L152.14 12.0599L150.803 14.0132L143.475 2.5489L144.785 0.466766Z",
    fill: "url(#paint4_linear_1587_9844)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1587_9844",
    x1: 0.552734,
    y1: 0.466766,
    x2: 26.123,
    y2: 45.2277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1587_9844",
    x1: 73.4521,
    y1: 0.466766,
    x2: 96.0804,
    y2: 49.3632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1587_9844",
    x1: 25.5,
    y1: 0.466766,
    x2: 46.931,
    y2: 50.6902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1587_9844",
    x1: 115.427,
    y1: 0.466766,
    x2: 138.744,
    y2: 48.5204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1587_9844",
    x1: 143.475,
    y1: 0.466766,
    x2: 150.608,
    y2: 17.8895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1587_9844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorGredientSizeRegular);
export default __webpack_public_path__ + "static/media/Color=Gredient, Size=Regular.0399a9558006c17ff3c783b68f7cc845.svg";
export { ForwardRef as ReactComponent };